
    import { TTableProps } from "../types/TableView";
    import TableView from "../components/TableView";

  const JatinList = ({searchLoading, columns, rows,showFilter, showPagination, showSearch, showPerPage, paginationData, onPageChange, onPerPageChange, handleSearchParams, searchPlaceholder }:TTableProps) => { 
   return (
    <div className='card'>
    <TableView
    columns={columns}
    rows={rows}
    showPagination={showPagination}
    showSearch={showSearch}
    showPerPage={showPerPage}
    paginationData={paginationData}
    onPageChange={onPageChange}
    onPerPageChange={onPerPageChange}
    handleSearchParams={handleSearchParams}
    searchPlaceholder={searchPlaceholder}
    showFilter={showFilter}
    searchLoading={searchLoading}
  />
    </div>
  );
};

export default JatinList;
    